import { render } from "./ResetPasswordView.vue?vue&type=template&id=05760fce"
import script from "./ResetPasswordView.vue?vue&type=script&lang=js"
export * from "./ResetPasswordView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__